<template>
<v-container id="dashboard" fluid tag="section" :key="ultimo_mes * ultimo_y * 10">

    <v-row>

        <!-- CUADRO 1 - DS -->
        <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card id="1" :key="'A'+pedimentosB+ remesasB" :selected="selected==1" color="blue" subTextColor="blue" icon="mdi-folder-zip-outline" title="Pedimentos " :value="pedimentosB" subtitle="Remesas" :smallValue="remesasB" subColor="black--text" sub-icon="mdi-clock-outline" sub-text="DATA STAGE" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' + mesB " :onClickBtn1="cambiarMesB" />
        </v-col>
        <v-dialog v-model="dialogA1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Data-Stage</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuB" v-model="menuB" :close-on-content-click="false" transition="scale-transition" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesB" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesB" color="secondary" scrollable locale="es-mx" @input="menuB = false" type="month">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menuB = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogA1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaA();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- CUADRO 4 - RECUPERACION DIARIA -->
        <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card id="4" :key="'D'+pedimentosD +remesasD" :selected="selected==4" color="green darken-4" subTextColor="green darken-4" icon="mdi-clock-outline" title="Pedimentos " :value="pedimentosD" subtitle="Remesas" :smallValue="remesasD" subColor="black--text" sub-icon="mdi-clock-outline" sub-text="Recuperación WS" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' + mesD " :onClickBtn1="cambiarMesD" />
        </v-col>
        <v-dialog v-model="dialogD1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Recuperación WS</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuD" v-model="menuD" :close-on-content-click="false" transition="scale-transition" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesD" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesD" color="secondary" scrollable locale="es-mx" @input="menuD = false" type="month">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menuD = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogD1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaD();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- CUADRO 2 - ARCHIVOS M -->
        <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card id="2" :key="'B'+total_correo_m+ total_sistema_m" :selected="selected==2" color="cyan darken-1" subTextColor="cyan darken-1" icon="mdi-file-powerpoint-outline" title="BANDEJA DE CORREO " :value="total_correo_m" :smallValue="total_sistema_m" subtitle="SISTEMA" subColor="black--text" sub-icon="mdi-text-box-plus-outline" sub-text="Archivos M" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'PERIODO: '+ model.fecha_de + ' - ' + model.fecha_a" :onClickBtn1="opendialogB1" />
        </v-col>
        <v-dialog v-model="dialogB1" max-width="600px">
            <v-card>

                <v-card-text>
                    <h5>Bandeja de Archivos M</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuA1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[validaMes(model.fecha_de, model.fecha_a), validaFechas(model.fecha_de, model.fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu1 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuA2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[validaMes(model.fecha_de, model.fecha_a), validaFechas(model.fecha_de, model.fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu2 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogB1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; selected=2; estadisticaTablaB();">Consultar</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CUADRO 3 - REVISION -->
        <v-col cols="12" sm="6" lg="3">
            <base-material-stats-card id="3" :key="'C'+ impoC+ expoC" :selected="selected==3" color="amber accent-4" subTextColor="amber accent-4" icon="mdi-file-search-outline" title="Importaciones" :value="impoC" :smallValue="expoC" subtitle="Exportaciones" subColor="black--text" sub-icon="mdi-file-search-outline" sub-text="Reconocimiento Aduanero DS" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' +mesC" :onClickBtn1="cambiarMesC" />
        </v-col>
        <v-dialog v-model="dialogC1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Pedimentos en Revisión</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuB" v-model="menuC" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesC" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesC" color="secondary" scrollable locale="es-mx" @input="menuC = false" type="month">
                                        <v-spacer />

                                        <v-btn @click="menuC = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogC1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaC();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-row>

    <v-row>

        <v-col cols="12" lg="12" style="padding-top:5px; padding-bottom:0px; margin-top:-40px;">

            <!-- TABLA 1 - DS -->
            <v-card v-if="selected==1 ">
                <v-card class="pa-2 blue white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN DATA STAGE
                </v-card>

                <v-dialog v-model="dialogA2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos Recuperación Diaria</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form2" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuA1" v-model="menuA1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaB_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaB_de = parseDate(fechaB_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaB_de, fechaB_a), validaFechas(fechaB_de, fechaB_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaB_de" color="secondary" scrollable locale="es-mx" @input="menuA1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuA1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuA2" v-model="menuA2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaB_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaB_a= parseDate(fechaB_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaB_de, fechaB_a), validaFechas(fechaB_de, fechaB_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaB_a" color="secondary" scrollable locale="es-mx" @input="menuA2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuA2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogA2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaA();">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline secondary--text font-weight-light "> PERIODO: {{fechaB_de}} - {{fechaB_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogA2 = !dialogA2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableB" :exportFields="data_tableB_excel" name="Recuperacion_Diaria.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </div>
                <v-client-table ref="vuetableB" :data="data_tableB" :columns="columns_tableB" :options="tableB_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="search">
                        <v-alert icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                </v-client-table>

            </v-card>
            <!-- TABLA 4 - RECUPERACION DIARIA -->
            <v-card v-if="selected==4 ">
                <v-card class="pa-2 green darken-4 white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN RECUPERACIÓN WS
                </v-card>

                <v-dialog v-model="dialogD2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos Recuperación WS</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form2" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuD1" v-model="menuD1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaD_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaD_de = parseDate(fechaD_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaD_de, fechaD_a), validaFechas(fechaD_de, fechaD_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaD_de" color="secondary" scrollable locale="es-mx" @input="menuD1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuD1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuD2" v-model="menuD2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaD_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaD_a= parseDate(fechaD_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaD_de, fechaD_a), validaFechas(fechaD_de, fechaD_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaD_a" color="secondary" scrollable locale="es-mx" @input="menuD2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuD2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogD2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaD();">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline secondary--text font-weight-light "> PERIODO: {{fechaD_de}} - {{fechaD_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogD2 = !dialogD2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableD" :exportFields="data_tableD_excel" name="Recuperacion_Diaria.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </div>
                <v-client-table ref="vuetableB" :data="data_tableD" :columns="columns_tableD" :options="tableD_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="search">
                        <v-alert icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                </v-client-table>

            </v-card>

            <!-- TABLA 2 - ARCHIVOS M -->
            <v-card v-if="selected==2" class="elevation-1 ">
                <v-card class="pa-2 cyan darken-1 white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    BANDEJA DE ENTRADA ARCHIVOS M
                </v-card>
                <v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <span class="overline secondary--text font-weight-light "> PERIODO: {{model.fecha_de}} - {{model.fecha_a}}
                            <v-btn light icon title="Seleccionar Periodo" @click="dialogB1 = !dialogB1" v-tippy>
                                <v-icon small color="secondary">mdi-calendar</v-icon>
                            </v-btn>
                        </span>
                        <exportar-excel :key="'export'+ selected" :data="datafiltered" :exportFields="tabla1.data_excel" name="Consulta_Archivos_M.xlsx">
                            <v-btn icon small dark color="success" title="Exportar Bitácora" v-tippy>
                                <v-icon dark>mdi-table</v-icon>
                            </v-btn>
                        </exportar-excel>
                    </v-card-actions>

                    <v-client-table id="vuetable1" ref="vuetable1" :key="'vuetable'+ selected" :data="datos" :columns="tabla1.columns" :options="tabla1.options">
                        <template slot="noResults">
                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                        </template>

                        <template slot="rfc_grupo" slot-scope="props">
                            <div>
                                {{ props.row.rfc_grupo }}
                            </div>
                        </template>

                        <template slot="actions" slot-scope="props">
                            <v-btn x-small fab dark icon color="red" title="Proforma ArchivoM" v-show="(props.row.key_pdf!=null && props.row.key_pdf!='')" @click="download_pdf(props.row.key_pdf)" v-tippy>
                                <v-icon dark>picture_as_pdf</v-icon>
                            </v-btn>

                        </template>

                    </v-client-table>

                </v-card-text>

            </v-card>
            <!-- TABLA 3 - EN REVISION -->
            <v-card v-if="selected==3">
                <v-card class="pa-2 amber accent-4 white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN RECONOCIMIENTO ADUANERO
                </v-card>

                <v-dialog v-model="dialogC2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos en Revisión</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form3" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuC1" v-model="menuC1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaC_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaC_de = parseDate(fechaC_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaC_de, fechaC_a), validaFechas(fechaC_de, fechaC_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaC_de" color="secondary" scrollable locale="es-mx" @input="menuC1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuA1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuC2" v-model="menuC2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaC_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaC_a= parseDate(fechaC_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaC_de, fechaC_a), validaFechas(fechaC_de, fechaC_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaC_a" color="secondary" scrollable locale="es-mx" @input="menuC2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuC2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogC2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaC(); estadisticaConsultaD()">Consultar</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline secondary--text font-weight-light "> {{fechaC_de}} - {{fechaC_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogC2 = !dialogC2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableC" :exportFields="data_tableC_excel" name="ReconocimientoAduanero.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>

                </div>
                <v-client-table ref="vuetableC" :data="data_tableC" :columns="columns_tableC" :options="tableC_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>

                </v-client-table>

            </v-card>

        </v-col>

    </v-row>
    <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important">
        <!-- GRAFICA 1 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica3">
                <base-material-chart-card :options="data_grafica1" color="light-blue darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Importaciones DS</h5>

                    <br />

                    <table class="table text-center">
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">PEDIMENTOS</span></td>
                            <td><span class="overline grey--text  font-weight-light">rectificaciones</span></td>
                        </tr>
                        <tr>

                            <td><span class="overline black--text  font-weight-light">{{totalA_G1}}</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalB_G1}}</span></td>
                        </tr>
                        <tr>

                        </tr>
                    </table>
                    <hr />
                    <div class="pl-5">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog1 = !dialog1" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">Año {{a1}}</span>
                        </v-btn>

                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog1" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Importaciones y Rectificaciones</h5>
                            <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="a1"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog1 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica1">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-col>

        <!-- GRAFICA 2 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica2">
                <base-material-chart-card :options="data_grafica2" color="teal darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Exportaciones DS</h5>
                    <br />

                    <table class="table text-center">
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">PEDIMENTOS</span></td>
                            <td><span class="overline grey--text  font-weight-light">rectificaciones</span></td>
                        </tr>
                        <tr>

                            <td><span class="overline black--text  font-weight-light">{{totalA_G2}}</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalB_G2}}</span></td>
                        </tr>
                        <tr>

                        </tr>
                    </table>

                    <hr />
                    <div class="pl-5">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog2 = !dialog2" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">Año {{a2}}</span>
                        </v-btn>
                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog2" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Importaciones y Rectificaciones</h5>
                            <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="a2"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog2 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica2">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-col>

        <!-- GRAFICA 3 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica3">
                <base-material-chart-card :options="data_grafica3" color="purple darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Remesas DS</h5>
                    <table class="table text-center">
                        <tr>
                            <td></td>
                            <td><span class="overline grey--text  font-weight-light">IMPO.</span></td>
                            <td> <span class="overline grey--text  font-weight-light">EXPO.</span></td>
                            <td> <span class="overline grey--text  font-weight-light">TOTAL</span></td>
                        </tr>
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">PEDIMENTOS</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalA_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight-light">{{totalB_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight">{{totalA_G3 + totalB_G3}}</span></td>
                        </tr>
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">REMESAS</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalC_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight-light">{{totalD_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight">{{totalC_G3 + totalD_G3}}</span></td>
                        </tr>
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">COMPLEMENTARIOS</span></td>
                            <td><span class="overline black--text  font-weight-light">0</span></td>
                            <td> <span class="overline black--text  font-weight-light">{{totalD_CT}}</span></td>
                            <td> <span class="overline black--text  font-weight">{{totalD_CT}}</span></td>
                        </tr>
                    </table>
                    <hr />
                    <div class="pl-5">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog3 = !dialog3" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">Año {{a3}}</span>
                        </v-btn>
                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog3" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Remesas</h5>
                            <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="a3"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog3 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica3">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-col>

    </v-row>
    <v-row ref="botones" style="margin:-0px !important; padding:0 !important">
        <v-col cols="12" lg="4" style="text-align:center">
            <v-btn small color="light-blue darken-4" @click="detallesGraficas('Importaciones')" v-scroll-to="{el:'#el'}">
                <v-icon x-small color="white">mdi-eye</v-icon>&nbsp; Detalle Importaciones
            </v-btn>

        </v-col>

        <v-col cols="12" lg="4" style="text-align:center">
            <v-btn small color="teal darken-4" @click="detallesGraficas('Exportaciones')">
                <v-icon x-small color="white">mdi-eye</v-icon>&nbsp; Detalle Exportaciones
            </v-btn>
        </v-col>
        <v-col cols="12" lg="4" style="text-align:right">

            <v-btn small color="red" @click="descargar_graficas">
                <v-icon small color="white">mdi-file-pdf-box</v-icon>&nbsp; Descargar Gráficas PDF
            </v-btn>
        </v-col>
    </v-row>
    <v-row v-if="data_tableG.length > 0" ref="tabla_detalle" style="margin:0 !important; padding:0 !important">
        <v-col cols="12" style="text-align:right">

            <div class="d-inline-flex text-right" style=" z-index:1;    width:100%">
                <h5 text-primary>{{titulo_detalle}}</h5>
                <v-spacer />
                <exportar-excel :data="data_tableG" :exportFields="data_tableG_excel" name="DetalleGrafica.xlsx">
                    <v-btn x-small icon color="green" title="Descargar Información" v-tippy>
                        <v-icon dark>mdi-table</v-icon>
                    </v-btn>
                </exportar-excel>
            </div>
            <v-client-table ref="vuetableG" :data="data_tableG" :columns="columns_tableG" :options="tableG_options" class="elevation-2 pa-2 footer-hide">
                <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>

                <div slot="peso_bruto_p" slot-scope="props" class="text-end">{{formatNumber(props.row.peso_bruto_p.toFixed(2))}}</div>
                <div slot="valor_dls_p" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_dls_p.toFixed(2))}}</div>
                <div slot="valor_total_p" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_total_p.toFixed(2))}}</div>
                <div slot="peso_bruto_r" slot-scope="props" class="text-end">{{formatNumber(props.row.peso_bruto_r.toFixed(2))}}</div>
                <div slot="valor_dls_r" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_dls_r.toFixed(2))}}</div>
                <div slot="valor_total_r" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_total_r.toFixed(2))}}</div>
            </v-client-table>

        </v-col>
    </v-row>
    <div id="el" style="height: 200px;"></div>
</v-container>
</template>

<script>
var colors_bars = [
    "#eb7601", //naranja
    "#ffde17", //amarillo
    "#006594", //azul
    "#56baec", // azul cielo
    "#ffffff" // azul cielo
];
import axios from "axios";
import moment from "moment";
//import Canvg from 'canvg';
import jsPDF from 'jspdf';
//import html2canvas from 'html2canvas';

//window.html2canvas = html2canvas

export default {
    name: "DashboardDashboard",

    data() {
        return {
            ultimo_mes: "01",
            ultimo_y: "2023",
            model: {
                rfc: [],
                usuario: "",
                fecha_de: "",
                fecha_a: "",
                nombre: "",
                proveedor: "",
                archivos: [],
            },
            es_grupo: 0,
            datos: [],
            dialog1: false,
            menu1: false,
            menu2: false,
            total_correo_m: 0,
            total_sistema_m: 0,
            anio_recuperacion: "",
            titulo_detalle: "",
            valid: true,
            loader: null,
            loading: false,
            pedimentosB: 0,
            remesasB: 0,
            pedimentosD: 0,
            remesasD: 0,
            consultaB: "",
            consultaC: {
                "impo": 0,
                "expo": 0
            },
            consultaD: "",
            coneliminados: false,
            consultaG1: "",
            consultaG2: "",
            consultaG3: "",

            tablaB: "",
            impoC: 0,
            expoC: 0,
            impoD: 0,
            expoD: 0,
            filtroB: "",
            correctos: 0,
            incorrectos: 0,
            selected: 1,
            fab: false,
            dialog1: false,
            dialog2: false,
            dialog3: false,
            menuB: false,
            menuC: false,
            menuD: false,
            dialogA1: false,
            dialogB1: false,
            dialogC1: false,
            dialogD1: false,
            dialogA2: false,
            dialogB2: false,
            dialogC2: false,
            dialogD2: false,
            menuA1: false,
            menuA2: false,
            menuB1: false,
            menuB2: false,
            menuC1: false,
            menuC2: false,
            menuD1: false,
            menuD2: false,
            fechaA_de: "",
            fechaA_a: "",
            fechaB_de: "",
            fechaB_a: "",
            fechaC_de: "",
            fechaC_a: "",
            fechaD_de: "",
            fechaD_a: "",
            mesA: "",
            mesB: "",
            mesC: "",
            mesD: "",
            mes1: "",
            mes2: "",
            mes3: "",
            a1: "",
            a2: "",
            a3: "",
            tabla1: {
                columns: [
                    "rfc_grupo",
                    "rfc",
                    "metadato",
                    "fecha",
                    "iniciales",
                    "origen",
                    "nombre_zip",
                    "numero_archivo",
                    "no_pedimento",
                    "fecha_pedimento",
                    "clave_pedimento",
                    "tipo_operacion",
                    "aduana",
                    "rfc_cfdi",
                    "razon_social_agencia",
                    "estatus",
                    "actions",
                ],
                options: {
                    filterable: true,
                    filterByColumn: false,
                    texts: {
                        filter: '',
                        filterPlaceholder: 'Buscar',
                    },
                    sortable: [
                        "rfc",
                        "metadato",
                        "rfc_grupo",
                        "fecha",
                        "iniciales",
                        "origen",
                        "nombre_zip",
                        "numero_archivo",
                        "no_pedimento",
                        "fecha_pedimento",
                        "clave_pedimento",
                        "tipo_operacion",
                        "aduana",
                        "rfc_cfdi",
                        "razon_social_agencia",
                        "estatus",
                    ],
                    orderBy: {
                        column: 'fecha',
                        ascending: false
                    },
                    headings: {
                        "rfc": "RFC Importador-Exportador",
                        "metadato": "Nombre Corto",
                        "rfc_grupo": "RFC Grupo Logístico",
                        "fecha": "Fecha Proceso",
                        "iniciales": "Usuario",
                        "origen": "Origen",
                        "nombre_zip": "Nombre de Referencia del Proceso",
                        "numero_archivo": "Archivo M",
                        "no_pedimento": "Número de Pedimento",
                        "fecha_pedimento": "Fecha Ped.",
                        "clave_pedimento": "Clave",
                        "tipo_operacion": "Tipo Operación",
                        "aduana": "Aduana ",
                        "rfc_cfdi": "RFC Agencia Aduanal",
                        "razon_social_agencia": "Razon Social Agencia Aduanal",
                        "estatus": "Estatus",
                        actions: "Acciones",
                    },
                },
                data_excel: {
                    "RFC Grupo Logístico": "rfc_grupo",
                    "RFC Importador-Exportador": "rfc",
                    "Nombre Corto": "metadato",
                    "Fecha Proceso": "fecha",
                    "Usuario": "iniciales",
                    "Origen": "origen",
                    "Nombre de Referencia del Proceso": "nombre_zip",
                    "Archivo M": "numero_archivo",
                    "Número de Pedimento": "no_pedimento",
                    "Fecha Ped.": "fecha_pedimento",
                    "Clave": "clave_pedimento",
                    "Tipo Operación": "tipo_operacion",
                    "Aduana": "aduana",
                    "RFC Agencia Aduanal": "rfc_cfdi",
                    "Razon Social Agencia Aduanal": "razon_social_agencia",
                    "Estatus": "estatus",
                },
            },
            data_grafica1: {
                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos",
                        data: [],
                        stack: "Pedimentos"
                    },
                    {
                        name: "Rectificaciones",
                        data: [],
                        stack: "Rectificaciones"
                    },

                ]
            },
            totalA_G1: 0,
            totalB_G1: 0,
            data_grafica2: {

                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos",
                        data: [],
                        stack: "Pedimentos"
                    },
                    {
                        name: "Rectificaciones",
                        data: [],
                        stack: "Rectificaciones"
                    },

                ]
            },
            totalA_G2: 0,
            totalB_G2: 0,
            data_grafica3: {
                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos Importaciones",
                        data: [],
                        stack: "Pedimentos Importaciones"
                    },
                    {
                        name: "Pedimentos Exportaciones",
                        data: [],
                        stack: "Pedimentos Exportaciones"
                    },
                    {
                        name: "Remesas Importaciones",
                        data: [],
                        stack: "Remesas Importaciones"
                    },
                    {
                        name: "Remesas Exportaciones",
                        data: [],
                        stack: "Remesas Exportaciones"
                    },
                    {
                        name: "Complementarios",
                        data: [],
                        stack: "Complementarios"
                    },

                ]
            },
            totalA_G3: 0,
            totalB_G3: 0,
            totalC_G3: 0,
            totalD_G3: 0,
            totalD_CT: 0,

            //MENSAJES DE CORREO
            data_tableA: [],
            columns_tableA: [
                "usuario",
                "referencia",
                "estatus",
                "error",
                "fecha",
                "mensaje",
            ],
            tableA_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                headings: {
                    "Usuario": "usuario",
                    "Referencia": "referencia",
                    "Estatus": "estatus",
                    "Error": "error",
                    "Fecha": "fecha",
                    "Mensaje": "mensaje"
                }
            },
            data_tableA_excel: {
                "Usuario": "usuario",
                "Referencia": "referencia",
                "Estatus": "estatus",
                "Error": "error",
                "Fecha": "fecha",
                "Mensaje": "mensaje"
            },

            //////////////////

            //TABLA CONSULTA DIARIA
            data_tableB: [],
            columns_tableB: [
                "RFC",
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"
            ],
            tableB_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "RFC": "RFC",
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableB_excel: {
                "RFC": "RFC",
                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"
            },

            //TABLA REVISION
            data_tableC: [],
            columns_tableC: [
                "RFC",
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "Estado",
                "DescripcionEstado",
                "SubEstado",
                "DescripcionSubEstado",
                "FechaCambio",
                "Secuencia",
                "Factura",
                "Cantidad",
                "Valor"

            ],
            tableC_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "RFC": "RFC",
                    "NoPedimento": "No. Pedimento",
                    "FechaPagoReal": "Fecha Pago",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "Estado": "Estado",
                    "DescripcionEstado": "Descripción Estado",
                    "SubEstado": "Subestado",
                    "DescripcionSubEstado": "Descripción Subestado",
                    "FechaCambio": "Fecha Cambio",
                    "Secuencia": "Secuencia",
                    "Factura": "Factura",
                    "Cantidad": "Cantidad",
                    "Valor": "Valor"
                }
            },
            data_tableC_excel: {
                "RFC": "RFC",
                "No. Pedimento": "NoPedimento",
                "Fecha Pago": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Fecha Estado": "FechaEstado",
                "Descripción": "Descripcion",
                "Numéro Prevalidador": "NumeroPrevalidador",
                "Estado": "Estado",
                "Descripción Edo.": "DescripcionEstado",
                "Subestado": "SubEstado",
                "Descripción Subestado": "DescripcionSubEstado",
                "Fecha Cambio": "FechaCambio",
                "Secuencia": "Secuencia",
                "Factura": "Factura",
                "Cantidad": "Cantidad",
                "Valor": "Valor"

            },

            //TABLA DETALLE GRAFICAS
            data_tableG: [],
            columns_tableG: [
                "tipo_operacion",
                "mes",
                "pedimentos",
                "remesas",
                "peso_bruto_p",
                "valor_dls_p",
                "valor_total_p",
                "rectificaciones",
                "peso_bruto_r",
                "valor_dls_r",
                "valor_total_r",

            ],
            tableG_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                orderBy: {
                    column: 'mes',
                    ascending: true
                },
                headings: {
                    "tipo_operacion": "Tipo Operación",
                    "mes": "Mes",
                    "pedimentos": "Pedimentos",
                    "remesas": "Remesas",
                    "peso_bruto_p": "Peso Bruto",
                    "valor_dls_p": "Valor DLS",
                    "valor_total_p": "Valor MN",
                    "rectificaciones": "Rectificaciones",
                    "peso_bruto_r": "Peso Bruto Rectificaciones",
                    "valor_dls_r": "Valor DLS Rectificaciones",
                    "valor_total_r": "Valor MN Rectificaciones",
                }
            },
            data_tableG_excel: {
                "Tipo Operación": "tipo_operacion",
                "Mes": "mes",
                "Pedimento": "pedimentos",
                "Remesas": "remesas",
                "Peso Bruto": "peso_bruto_p",
                "Valor Dolares": "valor_dls_p",
                "Valor Total": "valor_total_p",
                "Rectificaciones": "rectificaciones",
                "Peso Bruto Rectificaciones": "peso_bruto_r",
                "Valor DLS Rectificaciones": "valor_dls_r",
                "Valor MN Rectificaciones": "valor_total_r",

            },

            //TABLA WA
            data_tableD: [],
            columns_tableD: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"
            ],
            tableD_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableD_excel: {

                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"
            },
        };
    },

    computed: {
        datafiltered() {
            var x = this.selected;
            let result = [];
            if (this.$refs.vuetable1 != null) {
                result = this.$refs.vuetable1.allFilteredData;
                return result;
            } else {
                result = this.datos;
                return result;
            }
        },
        expediente() {
            return (

                this.$local_storage.get(
                    "BANDEJA.DE.CORREO"
                ) == 100
            );
        },
        is_consignatario() {
            return this.$local_storage.get("subtipo_usuario") == "embarcadores_consignatarios";
        },
        anios() {
            var f = new Date();
            let a = [];
            let y = f.getFullYear();
            let i = 1;
            for (i; i < 15; i++) {
                a.push(y)
                y = y - 1;
            }
            return a;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("Emanifiesto.bitacora") == 100;
        },

        ultimo_anio() {
            return this.$local_storage.get("last_year")
        }
    },
    mounted() {
      
        var f_de = new Date();
        var f_a = new Date();
        let d = f_a.getDate();
        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;

        let y_de = y;
        let m_de = '01';
        let d_de = '01'

        this.a1 = y;
        this.a2 = y;
        this.a3 = y;
        if (m < 10)
            m = '0' + m;

        if (d < 10)
            d = '0' + d;

        this.$store.state.ultimo_y = y;
        this.$store.state.ultimo_m = m;
        this.ultimo_mes = this.$store.state.ultimo_m;
        this.ultimo_y = this.$store.state.ultimo_y;


        this.mesB = y + "-" + m;
        this.mesC = y + "-" + m;
        this.mesD = y + "-" + m;

        let fecha_a = y + "-" + m + "-" + d;
        let fecha_de = y_de + "-" + m_de + "-" + d_de;
        this.fechaA_a = fecha_a;
        this.fechaA_de = fecha_de;
        this.fechaB_a = fecha_a;
        this.fechaB_de = fecha_de;
        this.fechaC_a = fecha_a;
        this.fechaC_de = y_de + "-" + m_de + "-01";
        this.fechaD_a = y + "-" + m + "-" + d;
        this.fechaD_de = y + "-" + m + "-01";
        this.selected = 1;

        this.model.rfc = [this.$local_storage.get("rfc")];
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.es_grupo = 0;

        var f2_de = new Date();
        var f2_a = new Date();

        f2_de.setDate(f2_de.getDate() - 60);

        let y2 = f2_a.getFullYear();
        let m2 = f2_a.getMonth() + 1;
        let d2 = f2_a.getDate();

        let y2_de = f2_de.getFullYear();
        let m2_de = f2_de.getMonth() + 1;
        let d2_de = f2_de.getDate();

        if (m2 < 10)
            m2 = '0' + m2;
        if (m2_de < 10)
            m2_de = '0' + m2_de;
        if (d2 < 10)
            d2 = '0' + d2;
        if (d2_de < 10)
            d2_de = '0' + d2_de;

        let fecha2_a = y2 + "-" + m2 + "-" + d2;
        let fecha2_de = y2_de + "-" + m2_de + "-" + d2_de;
        this.model.fecha_de = fecha2_de;
        this.model.fecha_a = fecha2_a;

        this.getAnioRecuperacion();

        this.estadisticaConsultaB();
        this.estadisticaConsultaD();
        this.estadisticaGrafica1();
        this.estadisticaGrafica2();
        this.estadisticaGrafica3();
    },
    created() {

    },

    methods: {
      
        opendialog1: function () {
            this.dialog1 = true
        },
        opendialogB1: function () {
            this.dialogB1 = true
        },
        getRfcGrupo: function (val) {
            if (val !== null) return val;
            else return "Sin Seleccionar";
        },
        getEstatus: function (estatus) {
            var arr_estatus = ["PROCESADO", "GENERADO", "DUPLICADO", "ARCHIVO NO VALIDO", "ERROR AL GENERAR", "MANIFESTACIÓN TRANSMITIDA"];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return estatus;
        },

        filterResult() {
            Event.$emit('vue-tables.filter::filtro', this.filtro);
        },
        complete(index) {
            this.list[index] = !this.list[index];
        },
        getAnioRecuperacion: function () {
            let id_cliente = this.$local_storage.get("id_cliente", 0);
            if (id_cliente > 0) {
                axios.get(this.$hostname + "clientes/" + id_cliente + "/")
                    .then(response => {
                        if (response.data != null && response.data.anio_recuperacion != null)
                            this.anio_recuperacion = response.data.anio_recuperacion;
                        else
                            this.anio_recuperacion = "";
                    })
                    .catch(error => {});
            }

        },

        async estadisticaConsultaA() {

            let m = this.mesB.split("-");
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 1,
                "anio": m[0],
                "mes": m[1],
                "rfc_filtro": this.$local_storage.get("rfc")
            }

            await axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {
                    this.consultaB = response.data;
                    this.remesasB = parseInt(this.consultaB.remesas) + parseInt(this.consultaB.remesas_desaduanados);
                    this.pedimentosB = parseInt(this.consultaB.pedimentos) + parseInt(this.consultaB.pedimentos_desaduanados);

                })
                .catch((error) => {
                    this.consultaB = {
                        "pedimentos": 0,
                        "remesas": 0,
                        "pedimentos_desaduanados": 0,
                        "remesas_desaduanados": 0
                    };
                    this.remesasB = 0;
                    this.pedimentosB = 0;

                }).then(() => {
                    this.dialogA1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaConsultaB() {

            let self = this;

            let data = {};
            if (this.es_grupo == 1) {
                data = {
                    rfc: [],
                    rfc_grupo: this.model.rfc,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    rfc_receptor: [],
                    rfc_origen: [],
                    rfc_destino: [],
                };
            } else {
                data = {
                    rfc: this.model.rfc,
                    rfc_grupo: [],
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    rfc_receptor: this.model.rfc,
                    rfc_origen: this.model.rfc,
                    rfc_destino: this.model.rfc,
                };
            }

            await axios.post("https://apireportes.econnectpro.mx/reportes/conteos_cartaporte/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.total_correo_m = res.data.archivosM.correo;
                        self.total_sistema_m = res.data.archivosM.sistema;

                    }
                })
                .catch(err => {
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        async estadisticaConsultaC() {

            let m = this.mesC.split("-");
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 3,
                "anio": m[0],
                "mes": m[1],
                "estados": ["310"],
                "rfc_filtro": this.$local_storage.get("rfc")
                // "estados": ["310", "330", "340", "410", "415", "420", "430", "440", "450", "460", "480", "481", "482", "490", "491", "510", "520", "530", "610", "620", "630", "720 ", "750", "760"]
            }

            await axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {
                    this.consultaC = response.data;
                    this.impoC = parseInt(this.consultaC.impo);
                    this.expoC = parseInt(this.consultaC.expo);
                })
                .catch((error) => {
                    this.consultaC = {
                        "impo": 0,
                        "expo": 0,
                    };
                    this.impoC = 0;
                    this.expoC = 0;

                }).then(() => {
                    this.dialogC1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaConsultaD() {

            let m = this.mesD.split("-");
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 1,
                "anio": m[0],
                "mes": m[1]
            }

            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.consultaD = response.data;
                    this.remesasD = parseInt(this.consultaD.remesas) + parseInt(this.consultaD.remesas_desaduanados);
                    this.pedimentosD = parseInt(this.consultaD.pedimentos) + parseInt(this.consultaD.pedimentos_desaduanados);

                })
                .catch((error) => {
                    this.consultaD = {
                        "pedimentos": 0,
                        "remesas": 0,
                        "pedimentos_desaduanados": 0,
                        "remesas_desaduanados": 0
                    };
                    this.remesasD = 0;
                    this.pedimentosD = 0;

                }).then(() => {
                    this.dialogD1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        estadisticaTablaD() {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 2,
                "fecha_de": this.fechaD_de,
                "fecha_a": this.fechaD_a,
            }

            axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {

                    self.data_tableD = response.data;
                    self.data_tableD.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.data_tableD = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogD2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },
        estadisticaTablaA() {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 2,
                "fecha_de": this.fechaB_de,
                "fecha_a": this.fechaB_a,
                "rfc_filtro": this.$local_storage.get("rfc")
            }

            axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {

                    self.data_tableB = response.data;
                    self.data_tableB.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                    this.data_tableB = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogA2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },
        estadisticaTablaB() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let self = this;
            let fecha = 0;
            if (this.fecha_factura)
                fecha = 1;

            let data = {
                rfc: this.model.rfc,
                es_grupo: this.es_grupo,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                fecha_pedimento: fecha
            };

            axios.post("https://apireportes.econnectpro.mx/reportes/get_bitacora_manifestacion_transportista/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha);
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_pedimento = this.parseDate(this.datos[k].fecha_pedimento);
                            this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
                            //    this.datos[k].proveedor = this.datos[k].proveedor==1:"WEB";"API";
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            if (this.datos[k].tipo_operacion == 1)
                                this.datos[k].tipo_operacion = 'Impo';

                            if (this.datos[k].tipo_operacion == 2)
                                this.datos[k].tipo_operacion = 'Expo';
                        }
                        let correo = this.datos.filter(item => {
                            return item.origen == "correo"
                        });

                        self.total_correo_m = correo.length;
                        self.total_sistema_m = this.datos.length - correo.length;

                    }
                })
                .catch(err => {

                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogB1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        estadisticaTablaC() {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 4,
                "fecha_de": this.fechaC_de,
                "fecha_a": this.fechaC_a,
                "estados": ["310"],
                "rfc_filtro": this.$local_storage.get("rfc")

                //   "estados": ["310", "330", "340", "410", "415", "420", "430", "440", "450", "460", "480", "481", "482", "490", "491", "510", "520", "530", "610", "620", "630", "720", "750", "760"]

            }

            axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {
                    this.data_tableC = response.data;
                    self.data_tableC.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                    this.data_tableC = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogC2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },

        async estadisticaGrafica1() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 5,
                "anio": this.a1,
                "rfc_filtro": this.$local_storage.get("rfc")
            }
            await axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {
                    let r = response.data;
                    let tp = 0;
                    let tr = 0;
                    let m = [];
                    let vp = [];
                    let vr = [];
                    let mes = "01";
                    if (r.Enero) {
                        m.push("Ene");
                        vp.push(r.Enero.pedimentos);
                        vr.push(r.Enero.reconocimientos);
                        tp = tp + r.Enero.pedimentos;
                        tr = tr + r.Enero.reconocimientos;
                        mes = "01";
                    }
                    if (r.Febrero) {
                        m.push("Feb");
                        vp.push(r.Febrero.pedimentos);
                        vr.push(r.Febrero.reconocimientos);
                        tp = tp + r.Febrero.pedimentos;
                        tr = tr + r.Febrero.reconocimientos;
                        mes = "02";
                    }
                    if (r.Marzo) {
                        m.push("Mar");
                        vp.push(r.Marzo.pedimentos);
                        vr.push(r.Marzo.reconocimientos);
                        tp = tp + r.Marzo.pedimentos;
                        tr = tr + r.Marzo.reconocimientos;
                        mes = "03";
                    }
                    if (r.Abril) {
                        m.push("Abr");
                        vp.push(r.Abril.pedimentos);
                        vr.push(r.Abril.reconocimientos);
                        tp = tp + r.Abril.pedimentos;
                        tr = tr + r.Abril.reconocimientos;
                        mes = "04";
                    }
                    if (r.Mayo) {
                        m.push("May");
                        vp.push(r.Mayo.pedimentos);
                        vr.push(r.Mayo.reconocimientos);
                        tp = tp + r.Mayo.pedimentos;
                        tr = tr + r.Mayo.reconocimientos;
                        mes = "05";
                    }
                    if (r.Junio) {
                        m.push("Jun");
                        vp.push(r.Junio.pedimentos);
                        vr.push(r.Junio.reconocimientos);
                        tp = tp + r.Junio.pedimentos;
                        tr = tr + r.Junio.reconocimientos;
                        mes = "06";
                    }
                    if (r.Julio) {
                        m.push("Jul");
                        vp.push(r.Julio.pedimentos);
                        vr.push(r.Julio.reconocimientos);
                        tp = tp + r.Julio.pedimentos;
                        tr = tr + r.Julio.reconocimientos;
                        mes = "07";
                    }
                    if (r.Agosto) {
                        m.push("Ago");
                        vp.push(r.Agosto.pedimentos);
                        vr.push(r.Agosto.reconocimientos);
                        tp = tp + r.Agosto.pedimentos;
                        tr = tr + r.Agosto.reconocimientos;
                        mes = "08";
                    }
                    if (r.Septiembre) {
                        m.push("Sep");
                        vp.push(r.Septiembre.pedimentos);
                        vr.push(r.Septiembre.reconocimientos);
                        tp = tp + r.Septiembre.pedimentos;
                        tr = tr + r.Septiembre.reconocimientos;
                        mes = "09";
                    }
                    if (r.Octubre) {
                        m.push("Oct");
                        vp.push(r.Octubre.pedimentos);
                        vr.push(r.Octubre.reconocimientos);
                        tp = tp + r.Octubre.pedimentos;
                        tr = tr + r.Octubre.reconocimientos;
                        mes = "10";
                    }
                    if (r.Noviembre) {
                        m.push("Nov");
                        vp.push(r.Noviembre.pedimentos);
                        vr.push(r.Noviembre.reconocimientos);
                        tp = tp + r.Noviembre.pedimentos;
                        tr = tr + r.Noviembre.reconocimientos;
                        mes = "11";
                    }
                    if (r.Diciembre) {
                        m.push("Dic");
                        vp.push(r.Diciembre.pedimentos);
                        vr.push(r.Diciembre.reconocimientos);
                        tp = tp + r.Diciembre.pedimentos;
                        tr = tr + r.Diciembre.reconocimientos;
                        mes = "12";
                    }
                    this.data_grafica1.xAxis.categories = m;
                    this.data_grafica1.series[0].data = vp;
                    this.data_grafica1.series[1].data = vr;
                    this.totalA_G1 = tp;
                    this.totalB_G1 = tr;
                    if (this.data_tableG.length > 0) {
                        this.detallesGraficas('Importaciones')
                    }
                    if (this.ultimo_mes < mes) {
                        this.ultimo_mes = mes;
                    }
                    var f_a = new Date();
                    let y = f_a.getFullYear();
                    this.mesB = y + "-" + this.ultimo_mes;
                    this.mesC = y + "-" + this.ultimo_mes;
                    var lastDayOfMonth = new Date(this.a2, parseInt(this.ultimo_mes), 0);

                    this.fechaB_de = y + "-" + this.ultimo_mes + "-01";
                    this.fechaB_a = y + "-" + this.ultimo_mes + "-" + lastDayOfMonth.getDate();

                    this.estadisticaConsultaA();
                    this.estadisticaConsultaC();
                    this.estadisticaTablaA();
                })
                .catch((error) => {
                    this.data_grafica1.xAxis.categories = [];
                    this.data_grafica1.series[0].data = [];
                    this.data_grafica1.series[1].data = [];
                    this.totalA_G1 = 0;
                    this.totalB_G1 = 0;
                    this.$root.$dialogLoader.hide();
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaGrafica2() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 6,
                "anio": this.a2,
                "rfc_filtro": this.$local_storage.get("rfc")
            }
            await axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {
                    let r = response.data;
                    let tp = 0;
                    let tr = 0;
                    let m = [];
                    let vp = [];
                    let vr = [];
                    let mes = "01";
                    if (r.Enero) {
                        m.push("Ene");
                        vp.push(r.Enero.pedimentos);
                        vr.push(r.Enero.reconocimientos);
                        tp = tp + r.Enero.pedimentos;
                        tr = tr + r.Enero.reconocimientos;
                        mes = "01";
                    }
                    if (r.Febrero) {
                        m.push("Feb");
                        vp.push(r.Febrero.pedimentos);
                        vr.push(r.Febrero.reconocimientos);
                        tp = tp + r.Febrero.pedimentos;
                        tr = tr + r.Febrero.reconocimientos;
                        mes = "02";
                    }
                    if (r.Marzo) {
                        m.push("Mar");
                        vp.push(r.Marzo.pedimentos);
                        vr.push(r.Marzo.reconocimientos);
                        tp = tp + r.Marzo.pedimentos;
                        tr = tr + r.Marzo.reconocimientos;
                        mes = "03";
                    }
                    if (r.Abril) {
                        m.push("Abr");
                        vp.push(r.Abril.pedimentos);
                        vr.push(r.Abril.reconocimientos);
                        tp = tp + r.Abril.pedimentos;
                        tr = tr + r.Abril.reconocimientos;
                        mes = "04";
                    }
                    if (r.Mayo) {
                        m.push("May");
                        vp.push(r.Mayo.pedimentos);
                        vr.push(r.Mayo.reconocimientos);
                        tp = tp + r.Mayo.pedimentos;
                        tr = tr + r.Mayo.reconocimientos;
                        mes = "05";
                    }
                    if (r.Junio) {
                        m.push("Jun");
                        vp.push(r.Junio.pedimentos);
                        vr.push(r.Junio.reconocimientos);
                        tp = tp + r.Junio.pedimentos;
                        tr = tr + r.Junio.reconocimientos;
                        mes = "06";
                    }
                    if (r.Julio) {
                        m.push("Jul");
                        vp.push(r.Julio.pedimentos);
                        vr.push(r.Julio.reconocimientos);
                        tp = tp + r.Julio.pedimentos;
                        tr = tr + r.Julio.reconocimientos;
                        mes = "07";
                    }
                    if (r.Agosto) {
                        m.push("Ago");
                        vp.push(r.Agosto.pedimentos);
                        vr.push(r.Agosto.reconocimientos);
                        tp = tp + r.Agosto.pedimentos;
                        tr = tr + r.Agosto.reconocimientos;
                        mes = "08";

                    }
                    if (r.Septiembre) {
                        m.push("Sep");
                        vp.push(r.Septiembre.pedimentos);
                        vr.push(r.Septiembre.reconocimientos);
                        tp = tp + r.Septiembre.pedimentos;
                        tr = tr + r.Septiembre.reconocimientos;
                        mes = "09";
                    }
                    if (r.Octubre) {
                        m.push("Oct");
                        vp.push(r.Octubre.pedimentos);
                        vr.push(r.Octubre.reconocimientos);
                        tp = tp + r.Octubre.pedimentos;
                        tr = tr + r.Octubre.reconocimientos;
                        mes = "10";
                    }
                    if (r.Noviembre) {
                        m.push("Nov");
                        vp.push(r.Noviembre.pedimentos);
                        vr.push(r.Noviembre.reconocimientos);
                        tp = tp + r.Noviembre.pedimentos;
                        tr = tr + r.Noviembre.reconocimientos;
                        mes = "11";
                    }
                    if (r.Diciembre) {
                        m.push("Dic");
                        vp.push(r.Diciembre.pedimentos);
                        vr.push(r.Diciembre.reconocimientos);
                        tp = tp + r.Diciembre.pedimentos;
                        tr = tr + r.Diciembre.reconocimientos;
                        mes = "12";
                    }
                    this.data_grafica2.xAxis.categories = m;
                    this.data_grafica2.series[0].data = vp;
                    this.data_grafica2.series[1].data = vr;
                    this.totalA_G2 = tp;
                    this.totalB_G2 = tr;
                    if (this.data_tableG.length > 0) {
                        this.detallesGraficas('Importaciones')
                    }

                    if (this.ultimo_mes < mes) {
                        this.ultimo_mes = mes;
                    }
                    var f_a = new Date();
                    let y = f_a.getFullYear();
                    this.mesB = y + "-" + this.ultimo_mes;
                    this.mesC = y + "-" + this.ultimo_mes;
                    var lastDayOfMonth = new Date(this.a2, parseInt(this.ultimo_mes), 0);

                    this.fechaB_de = y + "-" + this.ultimo_mes + "-01";
                    this.fechaB_a = y + "-" + this.ultimo_mes + "-" + lastDayOfMonth.getDate();

                    this.estadisticaConsultaA();
                    this.estadisticaConsultaC();
                    this.estadisticaTablaA();

                })
                .catch((error) => {
                    this.data_grafica2.xAxis.categories = [];
                    this.data_grafica2.series[0].data = [];
                    this.data_grafica2.series[1].data = [];
                    this.totalA_G2 = 0;
                    this.totalB_G2 = 0;
                    this.$root.$dialogLoader.hide();
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog2 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaGrafica3() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "tipo": 7,
                "anio": this.a3,
                "rfc_filtro": this.$local_storage.get("rfc")
            }
            await axios.post('https://apireportes.econnectpro.mx/reportes/estadisticas_agentes/', datos)
                .then((response) => {
                    let r = response.data;;
                    let tp_i = 0;
                    let tr_i = 0;
                    let tp_e = 0;
                    let tr_e = 0;
                    let tct = 0;
                    let m = [];
                    let vp_e = [];
                    let vr_e = [];
                    let vp_i = [];
                    let vr_i = [];
                    let vct = [];
                    if (r.Enero) {
                        m.push("Ene");
                        vp_i.push(r.Enero.pedimentos_impo);
                        vr_i.push(r.Enero.remesas_impo);
                        vp_e.push(r.Enero.pedimentos_expo);
                        vr_e.push(r.Enero.remesas_expo);

                        tp_i = tp_i + r.Enero.pedimentos_impo;
                        tr_i = tr_i + r.Enero.remesas_impo;
                        tp_e = tp_e + r.Enero.pedimentos_expo;
                        tr_e = tr_e + r.Enero.remesas_expo;

                        vct.push(r.Enero.pedimentos_ct);
                        tct = tct + r.Enero.pedimentos_ct;
                    }
                    if (r.Febrero) {
                        m.push("Feb");
                        vp_i.push(r.Febrero.pedimentos_impo);
                        vr_i.push(r.Febrero.remesas_impo);
                        vp_e.push(r.Febrero.pedimentos_expo);
                        vr_e.push(r.Febrero.remesas_expo);
                        tp_i = tp_i + r.Febrero.pedimentos_impo;
                        tr_i = tr_i + r.Febrero.remesas_impo;
                        tp_e = tp_e + r.Febrero.pedimentos_expo;
                        tr_e = tr_e + r.Febrero.remesas_expo;
                        vct.push(r.Febrero.pedimentos_ct);
                        tct = tct + r.Febrero.pedimentos_ct;
                    }
                    if (r.Marzo) {
                        m.push("Mar");
                        vp_i.push(r.Marzo.pedimentos_impo);
                        vr_i.push(r.Marzo.remesas_impo);
                        vp_e.push(r.Marzo.pedimentos_expo);
                        vr_e.push(r.Marzo.remesas_expo);
                        tp_i = tp_i + r.Marzo.pedimentos_impo;
                        tr_i = tr_i + r.Marzo.remesas_impo;
                        tp_e = tp_e + r.Marzo.pedimentos_expo;
                        tr_e = tr_e + r.Marzo.remesas_expo;
                        vct.push(r.Marzo.pedimentos_ct);
                        tct = tct + r.Marzo.pedimentos_ct;
                    }
                    if (r.Abril) {
                        m.push("Abr");
                        vp_i.push(r.Abril.pedimentos_impo);
                        vr_i.push(r.Abril.remesas_impo);
                        vp_e.push(r.Abril.pedimentos_expo);
                        vr_e.push(r.Abril.remesas_expo);
                        tp_i = tp_i + r.Abril.pedimentos_impo;
                        tr_i = tr_i + r.Abril.remesas_impo;
                        tp_e = tp_e + r.Abril.pedimentos_expo;
                        tr_e = tr_e + r.Abril.remesas_expo;
                        vct.push(r.Abril.pedimentos_ct);
                        tct = tct + r.Abril.pedimentos_ct;
                    }
                    if (r.Mayo) {
                        m.push("May");
                        vp_i.push(r.Mayo.pedimentos_impo);
                        vr_i.push(r.Mayo.remesas_impo);
                        vp_e.push(r.Mayo.pedimentos_expo);
                        vr_e.push(r.Mayo.remesas_expo);
                        tp_i = tp_i + r.Mayo.pedimentos_impo;
                        tr_i = tr_i + r.Mayo.remesas_impo;
                        tp_e = tp_e + r.Mayo.pedimentos_expo;
                        tr_e = tr_e + r.Mayo.remesas_expo;
                        vct.push(r.Mayo.pedimentos_ct);
                        tct = tct + r.Mayo.pedimentos_ct;
                    }
                    if (r.Junio) {
                        m.push("Jun");
                        vp_i.push(r.Junio.pedimentos_impo);
                        vr_i.push(r.Junio.remesas_impo);
                        vp_e.push(r.Junio.pedimentos_expo);
                        vr_e.push(r.Junio.remesas_expo);
                        tp_i = tp_i + r.Junio.pedimentos_impo;
                        tr_i = tr_i + r.Junio.remesas_impo;
                        tp_e = tp_e + r.Junio.pedimentos_expo;
                        tr_e = tr_e + r.Junio.remesas_expo;
                        vct.push(r.Junio.pedimentos_ct);
                        tct = tct + r.Junio.pedimentos_ct;
                    }
                    if (r.Julio) {
                        m.push("Jul");
                        vp_i.push(r.Julio.pedimentos_impo);
                        vr_i.push(r.Julio.remesas_impo);
                        vp_e.push(r.Julio.pedimentos_expo);
                        vr_e.push(r.Julio.remesas_expo);
                        tp_i = tp_i + r.Julio.pedimentos_impo;
                        tr_i = tr_i + r.Julio.remesas_impo;
                        tp_e = tp_e + r.Julio.pedimentos_expo;
                        tr_e = tr_e + r.Julio.remesas_expo;
                        vct.push(r.Julio.pedimentos_ct);
                        tct = tct + r.Julio.pedimentos_ct;
                    }
                    if (r.Agosto) {
                        m.push("Ago");
                        vp_i.push(r.Agosto.pedimentos_impo);
                        vr_i.push(r.Agosto.remesas_impo);
                        vp_e.push(r.Agosto.pedimentos_expo);
                        vr_e.push(r.Agosto.remesas_expo);
                        tp_i = tp_i + r.Agosto.pedimentos_impo;
                        tr_i = tr_i + r.Agosto.remesas_impo;
                        tp_e = tp_e + r.Agosto.pedimentos_expo;
                        tr_e = tr_e + r.Agosto.remesas_expo;
                        vct.push(r.Agosto.pedimentos_ct);
                        tct = tct + r.Agosto.pedimentos_ct;
                    }
                    if (r.Septiembre) {
                        m.push("Sep");
                        vp_i.push(r.Septiembre.pedimentos_impo);
                        vr_i.push(r.Septiembre.remesas_impo);
                        vp_e.push(r.Septiembre.pedimentos_expo);
                        vr_e.push(r.Septiembre.remesas_expo);
                        tp_i = tp_i + r.Septiembre.pedimentos_impo;
                        tr_i = tr_i + r.Septiembre.remesas_impo;
                        tp_e = tp_e + r.Septiembre.pedimentos_expo;
                        tr_e = tr_e + r.Septiembre.remesas_expo;
                        vct.push(r.Septiembre.pedimentos_ct);
                        tct = tct + r.Septiembre.pedimentos_ct;
                    }
                    if (r.Octubre) {
                        m.push("Oct");
                        vp_i.push(r.Octubre.pedimentos_impo);
                        vr_i.push(r.Octubre.remesas_impo);
                        vp_e.push(r.Octubre.pedimentos_expo);
                        vr_e.push(r.Octubre.remesas_expo);
                        tp_i = tp_i + r.Octubre.pedimentos_impo;
                        tr_i = tr_i + r.Octubre.remesas_impo;
                        tp_e = tp_e + r.Octubre.pedimentos_expo;
                        tr_e = tr_e + r.Octubre.remesas_expo;
                        vct.push(r.Octubre.pedimentos_ct);
                        tct = tct + r.Octubre.pedimentos_ct;
                    }
                    if (r.Noviembre) {
                        m.push("Nov");
                        vp_i.push(r.Noviembre.pedimentos_impo);
                        vr_i.push(r.Noviembre.remesas_impo);
                        vp_e.push(r.Noviembre.pedimentos_expo);
                        vr_e.push(r.Noviembre.remesas_expo);
                        tp_i = tp_i + r.Noviembre.pedimentos_impo;
                        tr_i = tr_i + r.Noviembre.remesas_impo;
                        tp_e = tp_e + r.Noviembre.pedimentos_expo;
                        tr_e = tr_e + r.Noviembre.remesas_expo;
                        vct.push(r.Noviembre.pedimentos_ct);
                        tct = tct + r.Noviembre.pedimentos_ct;
                    }
                    if (r.Diciembre) {
                        m.push("Dic");
                        vp_i.push(r.Diciembre.pedimentos_impo);
                        vr_i.push(r.Diciembre.remesas_impo);
                        vp_e.push(r.Diciembre.pedimentos_expo);
                        vr_e.push(r.Diciembre.remesas_expo);
                        tp_i = tp_i + r.Diciembre.pedimentos_impo;
                        tr_i = tr_i + r.Diciembre.remesas_impo;
                        tp_e = tp_e + r.Diciembre.pedimentos_expo;
                        tr_e = tr_e + r.Diciembre.remesas_expo;
                        vct.push(r.Diciembre.pedimentos_ct);
                        tct = tct + r.Diciembre.pedimentos_ct;
                    }
                    this.data_grafica3.xAxis.categories = m;
                    this.data_grafica3.series[0].data = vp_i;
                    this.data_grafica3.series[1].data = vp_e;
                    this.data_grafica3.series[2].data = vr_i;
                    this.data_grafica3.series[3].data = vr_e;
                    this.data_grafica3.series[4].data = vct;
                    this.totalA_G3 = tp_i;
                    this.totalB_G3 = tp_e;

                    this.totalC_G3 = tr_i;
                    this.totalD_G3 = tr_e;
                    this.totalD_CT = tct;

                })
                .catch((error) => {
                    console.log(error);
                    this.data_grafica3.xAxis.categories = [];
                    this.data_grafica3.series[0].data = [];
                    this.data_grafica3.series[1].data = [];
                    this.data_grafica3.series[2].data = [];
                    this.data_grafica3.series[3].data = [];
                    this.data_grafica3.series[4].data = [];
                    this.totalA_G3 = 0;
                    this.totalB_G3 = 0;
                    this.totalC_G3 = 0;
                    this.totalD_G3 = 0;
                    this.$root.$dialogLoader.hide();
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog3 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        selectItem(index) {
            this.selected = index;
            if (index == 1) {
                this.estadisticaTablaA();
            }
            if (index == 2) {
                this.estadisticaTablaB();
            }
            if (index == 3) {
                this.estadisticaTablaC();
            }
            if (index == 4) {
                this.estadisticaTablaD();
            }

        },
        cambiarMesB() {
            this.dialogA1 = true;
        },
        cambiarMesC() {
            this.dialogC1 = true;
        },
        cambiarMesD() {
            this.dialogD1 = true;
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            }
            return true;
        },
        validaMes: function (FD, FA) {
            if (FD != "" && FA != "") {
                var inicio = moment(FD, "YYYY-MM-DD");
                var fin = moment(FA, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 días. Favor de verificar.";
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        downloadProforma: function (key_pdf) {
            var datoss3 = {
                id: key_pdf,
                bucket: "facturas.abiertas.econectpro.mx"
            }
            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                            footer: '',
                        });
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();

                });
        },

        downloadFacturaProforma: function (filename, intento = 0) {
            var nombreZip = filename.toString() + ".pdf";
            var key = this.$local_storage.get("rfc") + "/reportes/" + nombreZip;
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }

            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if (intento > 3) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            setTimeout(function () {
                                thisObj.downloadFacturaProforma(filename, intento + 1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)
                        }

                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 3) {
                        setTimeout(function () {
                            thisObj.downloadFacturaProforma(filename, intento + 1);
                        }, 10000); //Damos tiempo para generar el zip (10 seg)
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }
                });

        },
        descargarFacturaProforma: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var filename = this.model_proforma["Folio Fiscal"];
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                archivo: filename,
                reporte_url: "/reportes_ws/proforma_factura_transito/",
                nombre_reporte: "Proforma Factura en Transito",
                tipo: "Proforma_Factura_Transito",
                usuario: this.$local_storage.get("id_usuario"),
            };
            var thisObj = this;
            axios.post(this.$hostname + "reportes/save_reporte/", datos)
                .then(res => {
                    setTimeout(function () {
                        thisObj.downloadFacturaProforma(filename, 1);
                    }, 10000); //Damos tiempo para generar el zip (10 seg)
                })
                .catch(error => {
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
                        var mensaje = error.response.data.mensaje;
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                    } else { //Si es un timeout intentamos descargar el archivo
                        setTimeout(function () {
                            thisObj.downloadFacturaProforma(filename, 1);
                        }, 10000); //Damos tiempo para generar el zip (10 seg)
                    }
                    console.log(error);
                });
        },
        download_pdf: function (key_pdf) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key_pdf,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        async descargar_graficas() {

            var pdf = new jsPDF('l', 'pt');
            const el = this.$refs.graficas_area;

            const options = {
                type: 'dataURL'
            }
            var url = await this.$html2canvas(el, options);

            pdf.setFontSize(20);
            pdf.addImage(url, 'PNG', 20, 80, 800, 320);
            pdf.text(30, 70, 'IMPORTACIONES Y EXPORTACIONES POR MES')
            pdf.save('graficas.pdf');

        },
        async detallesGraficas(tipo) {

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let a = 0;
            if (tipo == 'Importaciones')
                a = this.a1;
            else
                a = this.a2;
            this.titulo_detalle = tipo + " - " + a;
            var datos = {
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
                "anio": a,
                "rfc_filtro": this.$local_storage.get("rfc")
            };
            await axios.post('https://apireportes.econnectpro.mx/reportes/detalle_operaciones_mes_agentes/', datos)
                .then((response) => {
                    this.data_tableG = response.data;
                    this.data_tableG = this.data_tableG.filter(t => t.tipo_operacion === tipo);
                    this.data_tableG = this.data_tableG.sort(function (a, b) {
                        return a.mes - b.mes;
                    });

                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    this.data_tableD = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
            if (this.data_tableG.length > 0) {
                document.body.scrollTop = document.body.scrollHeight;
            }

        },
    }
};
</script>

<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}
</style>
